module.exports = __webpack_public_path__ + "img/user-police-tie.6eafdd42.svg";